import * as t from 'io-ts';
import { nullable } from '../../Decoding';
export const ApiValidationErrorDetails = t.interface({
    code: t.string,
    message: t.string,
    attribute: t.string,
    meta: t.unknown,
});
export const makeApiErrorDecoder = (code, details) => t.interface({
    message: t.string,
    code,
    details: nullable(details),
});
export const ApiValidationError = makeApiErrorDecoder(t.string, t.array(ApiValidationErrorDetails));
export const ApiValidationErrorPayload = t.interface({
    error: ApiValidationError,
});
